<template>
  <v-app>
    <left-drawer />
    <v-toolbar app prominent color="white">
      <h1 class="mr-3 px-2 hover-background-grey cursor-pointer">
        <router-link
          :to="{ name: 'Types' }"
          class="text-decoration-none primary--text"
        >
          FAQ
        </router-link>
      </h1>
      <h2>
        <span
          :class="{
            'display-block line-height-1-1': $vuetify.breakpoint.smAndDown
          }"
        >
          {{ pageTitle }}
        </span>
        <span v-show="pageSubtitle" class="subheading">
          in
        </span>
        <span v-show="pageSubtitle" class="subheading font-weight-bold">
          {{ pageSubtitle }}
        </span>
      </h2>
      <v-spacer />
      <v-btn outline color="primary" @click="logOut()">
        Log out
      </v-btn>
    </v-toolbar>

    <v-content>
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
      <snackbar />
    </v-content>
  </v-app>
</template>

<script>
import LeftDrawer from "@/components/LeftDrawer";
import Snackbar from "@/components/Snackbar";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Navshell",
  components: {
    LeftDrawer,
    Snackbar
  },
  computed: {
    ...mapGetters({
      leftDrawer: "ui/leftDrawer",
      pageSubtitle: "ui/pageSubtitle",
      pageTitle: "ui/pageTitle"
    })
  },
  methods: {
    ...mapActions({
      setLeftDrawer: "ui/setLeftDrawer",
      logOut: "auth/logOut"
    })
  }
};
</script>
